import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-question-edit-box',
    templateUrl: './question-edit-box.component.html',
    styleUrls: ['./question-edit-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuestionEditBoxComponent implements OnInit {

  @ViewChild('textAreaElement') textAreaElement: ElementRef;
  @Input() text: string;
  @Output() textChangeEmitter = new EventEmitter<string>();
  constructor() { }

  ngOnInit(): void {
  }

  submitTextChange(): void {
    this.textChangeEmitter.emit(this.textAreaElement.nativeElement.value);
  }

}
